import { ItemPositionSortOption } from '@rematter/frontend-lib-api-client';

import { ItemPositionRecord, PositionSummaryStats } from '../types/position';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const itemPositionsQueryAtom = createQueryAtomFactory(
  'trade.itemPositions',
  (params: {
    itemIds?: string[];
    facilityIds?: string[];
    searchTerm?: string;
    showOnlyNegative?: boolean;
    limit?: number;
    offset?: number;
    sorting?: ItemPositionSortOption[];
  }) => ({
    tradeItemPositions: {
      __args: {
        filter: {
          itemIds: params.itemIds,
          facilityIds: params.facilityIds,
          searchTerm: params.searchTerm,
          showOnlyNegative: params.showOnlyNegative,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 25,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        itemId: true,
        item: {
          id: true,
          name: true,
          skuNumber: true,
        },
        facilityId: true,
        facility: {
          id: true,
          facilityName: true,
        },
        currentInventory: true,
        incoming: true,
        outgoing: true,
        netPosition: true,
        unit: true,
      },
      stats: {
        totalItems: true,
        negativePositions: true,
        totalIncoming: true,
        totalOutgoing: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): {
      positions: ItemPositionRecord[];
      stats: PositionSummaryStats;
      totalCount: number;
    } => {
      if (
        !data ||
        !data.tradeItemPositions ||
        !data.tradeItemPositions.entries
      ) {
        return {
          positions: [],
          stats: {
            totalItems: 0,
            negativePositions: 0,
            totalIncoming: 0,
            totalOutgoing: 0,
          },
          totalCount: 0,
        };
      }

      return {
        positions: data.tradeItemPositions.entries.map((position) => ({
          id: `${position.itemId}-${position.facilityId || 'no-facility'}`,
          itemId: position.itemId,
          itemName: position.item?.name || '',
          itemSku: position.item?.skuNumber || '',
          facilityId: position.facilityId || undefined,
          facilityName: position.facility?.facilityName || undefined,
          currentInventory: position.currentInventory || 0,
          incoming: position.incoming || 0,
          outgoing: position.outgoing || 0,
          netPosition: position.netPosition || 0,
          unit: position.unit,
        })),
        stats: {
          totalItems: data.tradeItemPositions.stats?.totalItems || 0,
          negativePositions:
            data.tradeItemPositions.stats?.negativePositions || 0,
          totalIncoming: data.tradeItemPositions.stats?.totalIncoming || 0,
          totalOutgoing: data.tradeItemPositions.stats?.totalOutgoing || 0,
        },
        totalCount: data.tradeItemPositions.page?.total || 0,
      };
    },
  },
);
